import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sv2-step" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Your organization", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-step__subtitle" }, "This helps us tailor Ditto to your environment.", -1)
const _hoisted_4 = { class: "sv2-fields" }
const _hoisted_5 = { class: "sv2-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" Company or School Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_7 = { class: "sv2-input-wrap" }
const _hoisted_8 = { class: "sv2-input-wrap__icon" }
const _hoisted_9 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_10 = { class: "sv2-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode("Market"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_12 = { class: "sv2-select-wrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select market", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "sv2-select-wrap__caret" }
const _hoisted_16 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_17 = { class: "sv2-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" Number of displays"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_19 = { class: "sv2-select-wrap" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select range", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "sv2-select-wrap__caret" }
const _hoisted_23 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_24 = { class: "sv2-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "sv2-field__label" }, [
  /*#__PURE__*/_createTextVNode(" How do you plan to use Ditto?"),
  /*#__PURE__*/_createElementVNode("span", { class: "sv2-field__required" }, "*")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "sv2-field__error"
}
const _hoisted_27 = {
  key: 0,
  class: "sv2-crosssell"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-crosssell__title" }, "Looking for Ditto at home?", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-crosssell__body" }, " Ditto is built for business and education deployments. For personal screen mirroring, our consumer products may be a better fit. ", -1)
const _hoisted_30 = { class: "sv2-crosssell__links" }
const _hoisted_31 = {
  href: "https://www.airsquirrels.com/airparrot",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "sv2-crosssell__link"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-crosssell__link-name" }, "AirParrot"),
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-crosssell__link-desc" }, " Mirror your screen to Chromecast, Apple TV, and more. ")
], -1)
const _hoisted_33 = { class: "sv2-crosssell__link-arrow" }
const _hoisted_34 = {
  href: "https://www.airsquirrels.com/reflector",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "sv2-crosssell__link"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-crosssell__link-name" }, "Reflector"),
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-crosssell__link-desc" }, " Turn your computer into a receiver for iOS, Android, and Chromebook. ")
], -1)
const _hoisted_36 = { class: "sv2-crosssell__link-arrow" }
const _hoisted_37 = {
  key: 1,
  class: "sv2-field__error",
  style: {"margin-top":"16px"}
}
const _hoisted_38 = { class: "sv2-actions" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "sv2-spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_buildings = _resolveComponent("ph-buildings")!
  const _component_ph_caret_down = _resolveComponent("ph-caret-down")!
  const _component_ph_arrow_square_out = _resolveComponent("ph-arrow-square-out")!
  const _component_ph_arrow_left = _resolveComponent("ph-arrow-left")!
  const _component_ph_arrow_right = _resolveComponent("ph-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_ph_buildings, {
              size: 16,
              weight: "fill"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.orgName) = $event)),
            class: _normalizeClass(["sv2-input sv2-input--icon", { 'sv2-input--error': _ctx.showErrors && !_ctx.form.orgName }]),
            placeholder: "Acme Corp"
          }, null, 2), [
            [
              _vModelText,
              _ctx.form.orgName,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        (_ctx.showErrors && !_ctx.form.orgName)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "This field is required."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.market) = $event)),
            class: _normalizeClass(["sv2-input", {
                            'sv2-select--placeholder': !_ctx.form.market,
                            'sv2-input--error': _ctx.showErrors && !_ctx.form.market
                        }])
          }, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markets, (m) => {
              return (_openBlock(), _createElementBlock("option", {
                key: m,
                value: m
              }, _toDisplayString(m), 9, _hoisted_14))
            }), 128))
          ], 2), [
            [_vModelSelect, _ctx.form.market]
          ]),
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_component_ph_caret_down, {
              size: 14,
              weight: "bold"
            })
          ])
        ]),
        (_ctx.showErrors && !_ctx.form.market)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, "This field is required."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.numDisplays) = $event)),
            class: _normalizeClass(["sv2-input", {
                            'sv2-select--placeholder': !_ctx.form.numDisplays,
                            'sv2-input--error': _ctx.showErrors && !_ctx.form.numDisplays
                        }])
          }, [
            _hoisted_20,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayCounts, (d) => {
              return (_openBlock(), _createElementBlock("option", {
                key: d,
                value: d
              }, _toDisplayString(d), 9, _hoisted_21))
            }), 128))
          ], 2), [
            [_vModelSelect, _ctx.form.numDisplays]
          ]),
          _createElementVNode("span", _hoisted_22, [
            _createVNode(_component_ph_caret_down, {
              size: 14,
              weight: "bold"
            })
          ])
        ]),
        (_ctx.showErrors && !_ctx.form.numDisplays)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, "This field is required."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.plannedUse) = $event)),
          class: _normalizeClass(["sv2-input", { 'sv2-input--error': _ctx.showErrors && _ctx.plannedUseMissing }]),
          rows: "3",
          placeholder: "Share specifics — conference rooms, lobby signage, classroom instruction, digital menu boards…"
        }, null, 2), [
          [_vModelText, _ctx.form.plannedUse]
        ]),
        (_ctx.showErrors && _ctx.plannedUseMissing)
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, "This field is required."))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isHome)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("a", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("span", _hoisted_33, [
                _createVNode(_component_ph_arrow_square_out, {
                  size: 14,
                  weight: "bold"
                })
              ])
            ]),
            _createElementVNode("a", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("span", _hoisted_36, [
                _createVNode(_component_ph_arrow_square_out, {
                  size: 14,
                  weight: "bold"
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("button", {
        class: "sv2-btn-back",
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('back')))
      }, [
        _createVNode(_component_ph_arrow_left, {
          size: 14,
          weight: "bold"
        }),
        _createTextVNode(" Back ")
      ]),
      (_ctx.isHome)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "sv2-btn-subtle",
            type: "button",
            disabled: _ctx.submitting,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.submitting ? 'Setting up…' : 'Continue anyway') + " ", 1),
            (!_ctx.submitting)
              ? (_openBlock(), _createBlock(_component_ph_arrow_right, {
                  key: 0,
                  size: 14,
                  weight: "bold"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_39))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "sv2-btn-primary",
            type: "button",
            disabled: _ctx.submitting,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
          }, [
            (_ctx.submitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_41))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.submitting ? 'Setting up…' : 'Next') + " ", 1),
            (!_ctx.submitting)
              ? (_openBlock(), _createBlock(_component_ph_arrow_right, {
                  key: 1,
                  size: 16,
                  weight: "bold"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_40))
    ])
  ]))
}